import { Pipe, PipeTransform } from '@angular/core';
import { IProductMediaItem } from '@df/catalog/product/product';
import { CacheService } from '@df/core/cache/cache';
import { ProcessorService } from '@df/ng/processor.service';
import compact from 'lodash-es/compact';
import intersection from 'lodash-es/intersection';
import isArray from 'lodash-es/isArray';
import pick from 'lodash-es/pick';

@Pipe({
    name: 'filterMediaByLabel',
    standalone: true
})
export class FilterMediaByLabelPipe implements PipeTransform {
    transform = filterMediaByLabel;
}

export function filterMediaByLabel(
    media: IProductMediaItem[],
    labels: string | string[],
    invert: boolean
): IProductMediaItem[] | undefined {
    /**
     * Returns media objects with requested labels OR first image path in first mode
     *
     * To allow only items without label put 'none' into array.
     *
     * @param  {array}          media   Product media array.
     * @param  {array|string}   labels  Allowed labels as array or one label as string.
     * @param  {boolean}        first   If truthy then first matching image path will be returner.
     * @param  {boolean}        invert  if truthy then we return media objects withouth requested labels.
     * @return {array|string}           Filtered media or first matching image path.
     */
    if (!media) {
        return undefined;
    }

    labels = compact<string>(isArray(labels) ? labels : [labels]);

    if (!labels.length) {
        return media;
    }

    return ProcessorService.injector
        .get(CacheService)
        .get(['mediaLabelFilter', media.map(item => pick(item, ['image', 'labels'])), labels, invert], () => {
            const includeEmpty = labels.includes('none');

            const mediaItems = media.filter((item: IProductMediaItem) => {
                if ((!isArray(item.labels) || !item.labels.length) && !invert) {
                    return includeEmpty;
                }

                if (invert && !item.labels) {
                    return true;
                }

                return intersection(<string[]>item.labels, labels).length > 0 ? !invert : invert;
            });

            return mediaItems;
        });
}
